export function useBoardsHelpers() {
  const getWaves = (waves, boards) => {
    if (!Array.isArray(waves)) return [];
    return waves.slice(-4).map(wave => wave.id);
    console.warn("!! waves:", waves)
    console.warn("!! boards:", boards);
    // TODO: implement logic to get waves, used on the boards configuration
  };

  const getSurveys = (waves, boards) => {
    if (!Array.isArray(waves)) return [];
    // console.warn("!! waves:", waves)
    // console.warn("!! boards:", boards);
    const surveys = [
      ...new Set(waves.slice(-4)
        .flatMap(wave => Array.isArray(wave.SurveyId) ? wave.SurveyId : [])
    )];
    console.warn("!! surveys:", surveys);
    return surveys;
    // TODO: implement logic to get waves, used on the boards configuration
  };

  const getRelevantKpis = (boards) => {
    if (!Array.isArray(boards)) return [];
    const kpis =[
      ...new Set(
        boards.flatMap(board =>
          Array.isArray(board.controls)
            ? board.controls
                .filter(ctrl => typeof ctrl.kpiId === 'number')
                .map(ctrl => ctrl.kpiId)
            : []
        )
      )
    ];
    console.warn("!! boards:", boards);
    console.warn("!! relevant kpis:", kpis);
    return kpis;
  }
  return {
    getRelevantKpis,
    getSurveys,
    getWaves
  };
}
